import MessageThread from './MessageThread';

export default MessageThread;
